package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.TagElement
import org.w3c.dom.HTMLDetailsElement
import org.w3c.dom.HTMLElement

@Composable
fun Details(
    attrs: AttrBuilderContext<HTMLDetailsElement>? = null,
    content: ContentBuilder<HTMLDetailsElement>? = null,
) {
    TagElement(tagName = "details", applyAttrs = attrs, content = content)
}

@Composable
fun Summary(
    attrs: AttrBuilderContext<HTMLElement>? = null,
    content: ContentBuilder<HTMLElement>? = null,
) {
    TagElement(tagName = "summary", applyAttrs = attrs, content = content)
}
